<div class="cart-container p-6 max-w-5xl mx-auto">
  <!-- Cart Header -->
  <h2 class="text-3xl font-serif mb-6" style="color: var(--lt-color-text-dark);">Votre Panier</h2>

  <!-- Cart Items -->
  <div *ngIf="cartItems.length > 0; else emptyCart">
    <!-- Items List -->
    <div class="space-y-4">
      <div *ngFor="let item of cartItems; let i = index" class="flex flex-col sm:flex-row items-start sm:items-center gap-4 p-4 border rounded-lg" style="border-color: var(--lt-color-border-default); background-color: var(--lt-color-background-light);">
        <!-- Product Info -->
        <div class="flex-1">
          <h3 class="text-lg font-medium" style="color: var(--lt-color-text-default);">
            {{ item.product.name }}
            <span *ngIf="item.option?.label"> - {{ item.option.label }}</span>
          </h3>
          <p class="text-sm mt-1" style="color: var(--lt-color-text-light);">
            Prix unitaire: {{ (item.price * 13) | currency:'MAD':'symbol':'1.0-0' }}
          </p>
        </div>

        <!-- Quantity Control -->
        <div class="control flex items-center border rounded-lg p-2 h-12" style="border-color: var(--lt-color-border-default); background-color: var(--lt-color-background-light);">
          <button class="action minus w-8 h-8 flex items-center justify-center text-gold hover:bg-gray-100 transition-all duration-300 rounded-full"
                  type="button" title="Minus" (click)="decreaseQuantity(item)">
            <span class="text-xl">-</span>
          </button>
          <input type="number" [name]="'qty-' + i" [id]="'qty-' + i" min="1" [max]="maxQuantity" [(ngModel)]="item.quantity" (ngModelChange)="onQuantityChange(item)"
                 class="input-text qty w-16 h-8 text-center border-none focus:ring-0 text-base font-semibold text-gold bg-transparent"
                 style="color: var(--lt-color-text-dark);">
          <button class="action plus w-8 h-8 flex items-center justify-center text-gold hover:bg-gray-100 transition-all duration-300 rounded-full"
                  type="button" title="Plus" (click)="increaseQuantity(item)">
            <span class="text-xl">+</span>
          </button>
        </div>

        <!-- Item Total -->
        <div class="text-lg font-semibold w-24 text-right" style="color: var(--lt-color-text-default);">
          {{ (item.price * item.quantity * 13) | currency:'MAD':'symbol':'1.0-0' }}
        </div>

        <!-- Remove Button -->
        <button class="text-gold hover:text-red-600 transition-colors duration-300" (click)="removeItem(item)" title="Supprimer">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Cart Summary -->
    <div class="mt-8 flex justify-end">
      <div class="w-full sm:w-1/2 p-4 border rounded-lg" style="border-color: var(--lt-color-border-default); background-color: var(--lt-color-background-light);">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-xl font-medium" style="color: var(--lt-color-text-default);">Total</h3>
          <span class="text-2xl font-semibold" style="color: var(--lt-color-text-dark);">
            {{ totalPrice * 13 | currency:'MAD':'symbol':'1.0-0' }}
          </span>
        </div>
        <button (click)="proceedToCheckout()"
                class="add-to-cart-btn flex items-center justify-center transition-all duration-300 relative overflow-hidden bg-gradient-to-r from-gold to-yellow-600 hover:from-red-700 hover:to-red-600 text-white font-serif text-base sm:text-lg font-bold px-6 py-3 rounded-full w-full sm:w-auto">
          <span class="flex items-center">
            <i class="fas fa-credit-card mr-2"></i>
            <span>Proceed to Checkout</span>
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Empty Cart Message -->
  <ng-template #emptyCart>
    <div class="p-6 text-center border rounded-lg" style="border-color: var(--lt-color-border-default); background-color: var(--lt-color-background-light);">
      <p class="text-lg" style="color: var(--lt-color-text-default);">Votre panier est vide.</p>
      <a routerLink="/products" class="mt-4 inline-block px-6 py-3 text-gold hover:bg-gold hover:text-white transition-colors duration-300 border border-gold rounded-lg">
        Continuer vos achats
      </a>
    </div>
  </ng-template>
</div>
